import {useEffect} from 'react';
import {useApp} from '../../../contexts/AppContext';
import styled from 'styled-components';
import config from '../../../config';
import {Link} from 'react-router-dom';
import {NotLoginedHeaderArea} from '../../organisms/CommonParts';

const Page = styled.div`
`;

const Thanks = styled.div`
  height: 118px;

  align-items: center;
  font-weight: bold;
  font-size: 26px;
  display: flex;
  text-align: center;

  span {
    width: 100%;
    display: block;
  }
`;

export default function LoggedoutPage() {
  const app = useApp();

  useEffect(() => {
    app.hideHeader();
    window.logged_out_now = false;
    return () => {};
  }, []);

  return (
      <Page>
        <NotLoginedHeaderArea/>
        <Thanks>
          <span>You're now logged out.</span>
        </Thanks>
        <hr className="simple-border"/>
        <Link
            className="dark-button back-button center-fixed primary"
            to={`/`}
            style={{
              'margin-top': 40
            }}
        >
          <span>Go back to login</span>
        </Link>
      </Page>
  );
}
